// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared compact table cards — live preview + setup wizard */
.lt-coach-table {
  --lt-table-accent: var(--lt-brand, var(--brand-primary, #0877bc));
  --lt-card-bg: #1e293b;
  --lt-card-fg: #f8fafc;
  --lt-player-bg: #293548;
  --lt-player-border: rgba(255, 255, 255, 0.12);
  --lt-meta-fg: rgba(248, 250, 252, 0.65);
  border: 1px solid color-mix(in srgb, var(--lt-table-accent) 32%, rgba(255, 255, 255, 0.12));
  border-radius: 10px;
  padding: 8px 10px;
  background:
    linear-gradient(
      90deg,
      color-mix(in srgb, var(--lt-table-accent) 55%, transparent) 0,
      color-mix(in srgb, var(--lt-table-accent) 55%, transparent) 4px,
      transparent 4px
    ),
    var(--lt-card-bg);
  color: var(--lt-card-fg);
  text-align: left;
  width: 100%;
  min-height: 0;
  box-sizing: border-box;
}

.lt-coach-table--accent {
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--lt-table-accent) 18%, transparent);
}

.lt-coach-table--slot-empty {
  opacity: 0.35;
  border-style: dashed;
  background: rgba(30, 41, 59, 0.45);
  pointer-events: none;
}

.lt-coach-table__subgroup {
  display: inline-flex;
  align-items: center;
  max-width: 42%;
  padding: 2px 7px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--lt-table-accent) 55%, #fff);
  background: color-mix(in srgb, var(--lt-table-accent) 22%, transparent);
  color: #f8fafc;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

button.lt-coach-table {
  font: inherit;
  color: inherit;
  appearance: none;
}

.lt-coach-table--interactive {
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.lt-coach-table--interactive:not(:disabled):hover {
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.6);
}

.lt-coach-table--selected {
  border-color: var(--lt-brand, #0877bc);
  box-shadow: 0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
}

.lt-coach-table--pick-video:not(:disabled) {
  border-color: color-mix(in srgb, #f87171 55%, rgba(255, 255, 255, 0.2));
  box-shadow: inset 0 0 0 1px rgba(248, 113, 113, 0.18);
}

.lt-coach-table--video-selected {
  border-color: #ef5350;
  box-shadow: 0 0 0 2px rgba(239, 83, 80, 0.4);
}

.lt-coach-table--recording {
  border-color: #dc2626;
  box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.35);
}

.lt-coach-table--target:not(:disabled) {
  border-color: #f59e0b;
  background: rgba(245, 158, 11, 0.08);
}

.lt-coach-table__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-weight: 700;
  font-size: 0.78rem;
  margin-bottom: 6px;
  padding-bottom: 5px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-coach-table__number-cluster {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 6px;
  min-width: 0;
  max-width: 70%;
}

.lt-coach-table__identity {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 999px;
  border: 1px solid rgba(251, 191, 36, 0.55);
  background: rgba(251, 191, 36, 0.14);
  color: #fbbf24;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.3;
}

.lt-coach-table__number {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--lt-table-accent, var(--lt-brand-secondary, #46528b)) 55%, #fff);
  background: color-mix(in srgb, var(--lt-table-accent, var(--lt-brand-secondary, #46528b)) 22%, transparent);
  color: #f8fafc;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1.25;
  flex-shrink: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-coach-table__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 0;
}

.lt-coach-table__player {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.lt-coach-table__player--left {
  align-items: flex-start;
  text-align: left;
}

.lt-coach-table__player--right {
  align-items: flex-end;
  text-align: right;
}

.lt-coach-table__player--empty .lt-coach-table__name {
  color: rgba(248, 250, 252, 0.45);
  font-style: italic;
  font-weight: 500;
}

.lt-coach-table__row--open-seat {
  align-items: stretch;
}

.lt-coach-table__open-seat {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-self: stretch;
}

.lt-coach-table__open-seat--span {
  flex: none;
  width: 100%;
  margin-top: 4px;
}

.lt-coach-table__open-seat--right {
  align-items: flex-end;
}

.lt-coach-table__open-seat-label {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #fde68a;
}

.lt-coach-table__open-seat-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  max-height: 7.5rem;
  overflow-y: auto;
}

.lt-coach-table__open-seat--span .lt-coach-table__open-seat-list {
  flex-direction: row;
  flex-wrap: wrap;
}

.lt-coach-table__open-seat-list > li {
  margin: 0;
  min-width: 0;
  max-width: 100%;
}

.lt-coach-table__open-seat-btn {
  display: flex;
  align-items: baseline;
  gap: 6px;
  width: 100%;
  max-width: 100%;
  padding: 3px 6px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(15, 23, 42, 0.35);
  color: rgba(248, 250, 252, 0.92);
  font: inherit;
  font-size: 0.72rem;
  line-height: 1.2;
  text-align: left;
}

button.lt-coach-table__open-seat-btn {
  cursor: pointer;
}

button.lt-coach-table__open-seat-btn:hover {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);
}

.lt-coach-table__open-seat--right .lt-coach-table__open-seat-btn {
  text-align: right;
  flex-direction: row-reverse;
}

.lt-coach-table__open-seat-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
}

.lt-coach-table__open-seat-stats {
  flex-shrink: 0;
  opacity: 0.7;
  font-size: 0.64rem;
  font-variant-numeric: tabular-nums;
}

.lt-coach-table__player--btn {
  border: 2px solid var(--lt-player-border);
  border-radius: 6px;
  background-color: var(--lt-player-bg);
  padding: 4px 6px;
  cursor: pointer;
  color: var(--lt-card-fg);
  font: inherit;
  min-width: 0;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  box-sizing: border-box;
}

.lt-coach-table__player--btn[aria-disabled="true"] {
  opacity: 0.55;
  cursor: not-allowed;
  pointer-events: none;
}

.lt-coach-table__player--btn:not([aria-disabled="true"]):hover {
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55);
  background-color: #3f4f63;
}

.lt-coach-table__player--swappable {
  border: 1.5px solid
    color-mix(in srgb, var(--lt-brand, #0877bc) 45%, rgba(255, 255, 255, 0.16)) !important;
  background-color: color-mix(
    in srgb,
    var(--lt-brand, #0877bc) 10%,
    var(--lt-player-bg)
  ) !important;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.lt-coach-table__player--swappable:hover {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 80%, #fff) !important;
  background-color: color-mix(
    in srgb,
    var(--lt-brand, #0877bc) 20%,
    var(--lt-player-bg)
  ) !important;
}

.light-mode .lt-coach-table__player--swappable,
html[data-theme="light"] .lt-coach-table__player--swappable {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 32%, #cbd5e1) !important;
  background-color: color-mix(in srgb, var(--lt-brand, #0877bc) 6%, #f8fafc) !important;
}

.light-mode .lt-coach-table__player--swappable:hover,
html[data-theme="light"] .lt-coach-table__player--swappable:hover {
  border-color: var(--lt-brand, #0877bc) !important;
  background-color: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #ffffff) !important;
}

@keyframes lt-coach-table-swappable-pulse {
  0%,
  100% {
    box-shadow:
      0 0 0 1px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3),
      0 0 10px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);
  }
  50% {
    box-shadow:
      0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.5),
      0 0 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.32);
  }
}

.lt-coach-table__player--selected {
  border-width: 2px !important;
  border-style: solid !important;
  border-color: var(--lt-brand, #0877bc) !important;
  box-shadow:
    0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45),
    0 0 14px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
  background-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, var(--lt-player-bg)) !important;
  color: var(--lt-card-fg);
  animation: lt-coach-table-selected-glow 1.6s ease-in-out infinite;
  z-index: 1;
}

.lt-coach-table__player--target:not([aria-disabled="true"]) {
  border-width: 2px !important;
  border-style: dashed !important;
  border-color: #f59e0b !important;
  background-color: color-mix(in srgb, #f59e0b 22%, var(--lt-player-bg)) !important;
  color: var(--lt-card-fg);
  box-shadow:
    0 0 0 2px rgba(245, 158, 11, 0.5),
    inset 0 0 0 1px rgba(253, 230, 138, 0.2);
  animation: lt-coach-table-target-pulse 1.25s ease-in-out infinite;
  z-index: 1;
}

.lt-coach-table__player--dimmed {
  opacity: 0.38;
  pointer-events: none;
  filter: grayscale(0.35);
}

.lt-coach-table__player--flash {
  animation: lt-coach-table-swap-flash 1.1s ease-out forwards;
}

@keyframes lt-coach-table-swap-flash {
  0% {
    border-color: rgba(74, 222, 128, 0.95) !important;
    background-color: #14532d !important;
    box-shadow: 0 0 0 2px rgba(74, 222, 128, 0.55);
    opacity: 1;
  }
  55% {
    border-color: rgba(74, 222, 128, 0.7) !important;
    background-color: #166534 !important;
    opacity: 1;
  }
  100% {
    border-color: rgba(255, 255, 255, 0.12);
    background-color: #334155;
    box-shadow: none;
    opacity: 1;
  }
}

.lt-coach-table__seat-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 5px;
  border-radius: 999px;
  border: 1px solid rgba(125, 211, 252, 0.45);
  background: rgba(14, 165, 233, 0.18);
  color: #bae6fd;
  font-size: 0.62rem;
  font-weight: 800;
}

.lt-coach-table__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-height: 0;
  overflow: visible;
}

/* 3+: two columns — first half left, second half right; card hugs content */
.lt-coach-table__list--halves {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 3px 6px;
  align-content: start;
  flex: 0 0 auto;
  overflow: visible;
}

.lt-coach-table__list-col {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.lt-coach-table__list--scroll {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: calc(4 * 2.15rem + 12px);
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  padding-right: 2px;
}

.lt-coach-table--multi {
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 0;
  justify-content: flex-start;
  overflow: visible;
  padding: 6px 8px;
}

.lt-coach-table--multi .lt-coach-table__head {
  flex-shrink: 0;
  margin-bottom: 4px;
  padding-bottom: 4px;
}

/* Dual cards keep default .lt-coach-table padding (8px 10px / dialog override) */

.lt-coach-table__list-row {
  width: 100%;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  gap: 4px;
  align-items: center;
  padding: 2px 5px;
  border-radius: 6px;
  border: 1px solid var(--lt-player-border);
  background: var(--lt-player-bg);
  color: var(--lt-card-fg);
  text-align: left;
  cursor: default;
  min-width: 0;
  min-height: 2.1rem;
  box-sizing: border-box;
}

.lt-coach-table__list-col > li {
  min-width: 0;
}

.lt-coach-table__list-row--classement {
  min-height: 2.2rem;
}

.lt-coach-table__list--halves .lt-coach-table__list-side {
  width: 16px;
  height: 16px;
  font-size: 0.58rem;
}

.lt-coach-table__list--halves .lt-coach-table__list-name {
  font-size: 0.68rem;
}

.lt-coach-table__list--halves .lt-coach-table__list-meta {
  font-size: 0.52rem;
}

.lt-coach-table__rating {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
  min-width: 0;
  max-width: 100%;
  margin-top: 1px;
}

.lt-coach-table__rating .lt-coach-table__stats {
  display: inline;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}

.lt-coach-table__list-meta.lt-coach-table__rating {
  display: flex;
  margin-top: 1px;
  gap: 4px;
  line-height: 1.15;
}

.lt-coach-table__list-role {
  color: var(--lt-meta-fg, rgba(248, 250, 252, 0.62));
  white-space: nowrap;
}

.lt-coach-table__list-role--active {
  color: #86efac;
  font-weight: 700;
}

.lt-coach-table__list-role--sparring {
  color: #fb923c;
  font-weight: 700;
}

.lt-coach-table__list-role--both {
  color: #7dd3fc;
  font-weight: 700;
}

.lt-coach-table__list-role:not(:first-child)::before {
  content: "·";
  margin-right: 4px;
  opacity: 0.7;
}

.lt-coach-table__classement {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.4rem;
  padding: 1px 5px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #fff);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);
  color: #e0f2fe;
  font-size: 0.6rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1.15;
}

.lt-coach-table__player--has-classement {
  gap: 2px;
}

.lt-coach-table__player--has-classement .lt-coach-table__classement {
  font-size: 0.62rem;
  padding: 1px 6px;
}

.lt-coach-table__list-row.is-interactive {
  cursor: pointer;
}

.lt-coach-table__list-row.is-interactive:hover {
  border-color: rgba(125, 211, 252, 0.55);
  background: #2d4a63;
}

.lt-coach-table__list-row.is-selected {
  border-width: 2px;
  border-style: solid;
  border-color: var(--lt-brand, #0877bc) !important;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, var(--lt-player-bg));
  box-shadow:
    0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45),
    0 0 14px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
  animation: lt-coach-table-selected-glow 1.6s ease-in-out infinite;
  z-index: 1;
}

.lt-coach-table__list-row.is-target {
  border-width: 2px;
  border-style: dashed;
  border-color: #f59e0b !important;
  background: color-mix(in srgb, #f59e0b 22%, var(--lt-player-bg));
  box-shadow:
    0 0 0 2px rgba(245, 158, 11, 0.5),
    inset 0 0 0 1px rgba(253, 230, 138, 0.18);
  animation: lt-coach-table-target-pulse 1.25s ease-in-out infinite;
  z-index: 1;
}

.lt-coach-table__list-row.is-dimmed {
  opacity: 0.38;
  pointer-events: none;
  filter: grayscale(0.35);
}

.lt-coach-table__list-row:disabled {
  opacity: 0.92;
  cursor: default;
}

.lt-coach-table__list-row.is-dimmed:disabled {
  opacity: 0.38;
}

.lt-coach-table__list-side {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 0.65rem;
  font-weight: 800;
}

.lt-coach-table__list-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.lt-coach-table__list-name {
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.lt-coach-table__list-meta {
  font-size: 0.58rem;
  font-weight: 600;
  color: var(--lt-meta-fg, rgba(248, 250, 252, 0.62));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  margin-top: 1px;
}

.lt-coach-table__player--btn .lt-coach-table__name,
.lt-coach-table__player--btn .lt-coach-table__stats,
.lt-coach-table__player--btn .lt-coach-table__side,
.lt-coach-table__player--btn .lt-coach-table__role {
  color: inherit;
}

.lt-coach-table__player--btn .lt-coach-table__name {
  color: #f8fafc;
}

.lt-coach-table__player--btn .lt-coach-table__stats {
  color: rgba(248, 250, 252, 0.78);
}

.lt-coach-table__player--btn .lt-coach-table__side {
  color: rgba(248, 250, 252, 0.62);
}

.lt-coach-table__player-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.lt-coach-table__player--right .lt-coach-table__player-meta {
  justify-content: flex-end;
}

.lt-coach-table__side {
  font-size: 0.6rem;
  font-weight: 800;
  color: rgba(248, 250, 252, 0.5);
  letter-spacing: 0.04em;
}

.lt-coach-table__role {
  font-size: 0.58rem;
  font-weight: 700;
  padding: 0 5px;
  border-radius: 4px;
}

.lt-coach-table__role--active {
  background: rgba(34, 197, 94, 0.2);
  color: #86efac;
}

.lt-coach-table__role--sparring {
  background: rgba(243, 140, 41, 0.22);
  color: #fb923c;
}

.lt-coach-table__role--both {
  background: rgba(56, 189, 248, 0.2);
  color: #7dd3fc;
}

.lt-coach-table__hr-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
  padding: 2px 7px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.28);
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.68rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #f8fafc;
  line-height: 1.2;
}

.lt-coach-table__player--right .lt-coach-table__hr-chip {
  align-self: flex-end;
}

.lt-coach-table__hr-icon {
  color: #ef4444;
  font-size: 0.75rem !important;
}

.lt-coach-table__personalized {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 3px;
  max-width: 100%;
  min-width: 0;
}

.lt-coach-table__personalized-name {
  font-size: 0.64rem;
  font-weight: 650;
  font-style: italic;
  color: #fde68a;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-coach-table__personalized-edit {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: rgba(253, 230, 138, 0.16);
  color: #fde68a;
  cursor: pointer;
  font-size: 0.85rem;
}

.lt-coach-table__personalized-edit:hover {
  background: rgba(253, 230, 138, 0.32);
}

.lt-coach-table__player--right .lt-coach-table__personalized {
  align-self: flex-end;
}

.lt-coach-table__name {
  display: block;
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1.2;
  color: #f8fafc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.lt-coach-table__name--voice-hold {
  cursor: pointer;
  touch-action: manipulation;
  -webkit-user-select: none;
  user-select: none;
}

.lt-coach-table__name--voice-hold:active {
  color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 45%, #f8fafc);
}

.lt-coach-table__stats {
  display: block;
  font-size: 0.68rem;
  color: rgba(248, 250, 252, 0.55);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.lt-coach-table__vs {
  flex-shrink: 0;
  font-size: 0.62rem;
  font-weight: 800;
  color: rgba(248, 250, 252, 0.35);
  padding: 0 2px;
}

.lt-coach-table__score-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 0.95rem;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.lt-coach-table__score-win {
  color: #86efac;
}

.lt-coach-table__score-lose {
  color: rgba(248, 250, 252, 0.45);
}

.lt-coach-table__score-sep {
  color: rgba(248, 250, 252, 0.35);
  font-weight: 600;
}

.lt-coach-table__player--swap-warn:not([aria-disabled="true"]) {
  border-color: rgba(239, 68, 68, 0.55) !important;
  background-color: #4a2424 !important;
}

.lt-coach-table__player--swapping {
  border-color: rgba(56, 189, 248, 0.7) !important;
  background-color: #1e3a4f !important;
  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25);
  animation: lt-coach-table-swap-pulse 1.1s ease-in-out infinite;
  position: relative;
  overflow: hidden;
}

.lt-coach-table__player--swapping::after {
  content: "";
  position: absolute;
  inset: -1px;
  border-radius: 6px;
  border: 2px solid rgba(125, 211, 252, 0.55);
  animation: lt-coach-table-swap-ring 1.4s ease-out infinite;
  pointer-events: none;
}

@keyframes lt-coach-table-selected-glow {
  0%,
  100% {
    box-shadow:
      0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4),
      0 0 12px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
  }
  50% {
    box-shadow:
      0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.65),
      0 0 22px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45);
  }
}

@keyframes lt-coach-table-target-pulse {
  0%,
  100% {
    box-shadow:
      0 0 0 2px rgba(245, 158, 11, 0.45),
      inset 0 0 0 1px rgba(253, 230, 138, 0.15);
    background-color: #4a3a18;
  }
  50% {
    box-shadow:
      0 0 0 2px rgba(251, 191, 36, 0.85),
      inset 0 0 0 1px rgba(253, 230, 138, 0.28);
    background-color: #5c4518;
  }
}

@keyframes lt-coach-table-swap-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.88;
    transform: scale(0.99);
  }
}

@keyframes lt-coach-table-swap-ring {
  0% {
    opacity: 0.85;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.06);
  }
}

.lt-coach-table__swap-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  align-self: flex-start;
  margin-bottom: 4px;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 0.6rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.3;
  white-space: nowrap;
}

.lt-coach-table__player--right .lt-coach-table__swap-badge {
  align-self: flex-end;
}

.lt-coach-table__swap-badge svg {
  font-size: 0.85rem !important;
}

.lt-coach-table__swap-badge--selected {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55);
  color: #bae6fd;
}

.lt-coach-table__swap-badge--target {
  background: rgba(245, 158, 11, 0.22);
  border: 1px solid rgba(245, 158, 11, 0.55);
  color: #fde68a;
  animation: lt-coach-table-badge-bounce 1.4s ease-in-out infinite;
}

.lt-coach-table__swap-badge--swapping {
  background: rgba(56, 189, 248, 0.2);
  border: 1px solid rgba(56, 189, 248, 0.5);
  color: #bae6fd;
}

.lt-coach-table__swap-spin {
  animation: lt-coach-table-swap-spin 0.9s linear infinite;
}

@keyframes lt-coach-table-swap-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes lt-coach-table-badge-bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-1px);
  }
}

.lt-coach-table__swap-retry {
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid rgba(239, 68, 68, 0.45);
  background: rgba(239, 68, 68, 0.14);
  color: #fecaca;
  font-size: 0.62rem;
  font-weight: 700;
  cursor: pointer;
  font: inherit;
}

.lt-coach-table__tap-hint {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.62rem;
  font-weight: 700;
  color: #fcd34d;
}

.lt-coach-table--done {
  border-color: rgba(34, 197, 94, 0.35);
  background: rgba(34, 197, 94, 0.08);
}

.lt-coach-table--done.lt-coach-table--interactive:not(:disabled) {
  cursor: default;
  opacity: 0.92;
}

.lt-coach-table__record-menu {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  min-width: 200px;
  background: white;
}

.lt-coach-table__record-menu-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: none;
  background: transparent;
  color: #1e293b;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s;
}

.lt-coach-table__record-menu-btn:hover {
  background: #f1f5f9;
}

.lt-coach-table__player--pick-target {
  outline: 2px dashed rgba(251, 191, 36, 0.85);
  outline-offset: 2px;
  border-radius: 8px;
  cursor: pointer;
}

.lt-coach-table__player--pick-target .lt-coach-table__name--voice-hold {
  color: #fcd34d;
}

.lt-coach-table__player--recording {
  outline: 2px solid rgba(239, 68, 68, 0.75);
  outline-offset: 2px;
  border-radius: 8px;
}

.lt-coach-table__stop-capture-btn,
.lt-coach-table__start-capture-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 8px;
  border-radius: 6px;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: inherit;
  cursor: pointer;
}

.lt-coach-table__stop-capture-btn svg,
.lt-coach-table__start-capture-btn svg {
  font-size: 1em;
}

.lt-coach-table__stop-capture-btn {
  border: 1px solid #ef4444;
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.lt-coach-table__start-capture-btn {
  border: 1px solid rgba(248, 113, 113, 0.75);
  background: rgba(239, 68, 68, 0.18);
  color: #fecaca;
}

.lt-coach-table__start-capture-btn:hover {
  background: rgba(239, 68, 68, 0.3);
  color: #fff;
}

.lt-recording-indicator.blinking {
  animation: blink 1s infinite;
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

.lt-coach-table__hr-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  min-height: 36px;
  margin-left: auto;
  padding: 6px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.25);
  color: #f8fafc;
  cursor: pointer;
}

.lt-coach-table__hr-toggle:hover {
  background: rgba(8, 119, 188, 0.25);
}

.lt-coach-table__eval-video {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 36px;
  min-height: 36px;
  margin-left: auto;
  padding: 6px 8px;
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 60%, transparent);
  border-radius: 10px;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 85%, #0f172a);
  color: #fff;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
}

.lt-coach-table__eval-video:hover {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 75%, #fff);
}

.lt-coach-table__eval-video + .lt-coach-table__hr-toggle {
  margin-left: 6px;
}

.lt-coach-table__eval-video-count {
  line-height: 1;
}

.lt-coach-table--hr-trend .lt-coach-table__row {
  align-items: stretch;
}

.lt-coach-table__player--hr-trend {
  gap: 6px;
  min-width: 0;
}

.lt-coach-table--hr-trend {
  overflow: visible;
}

.lt-coach-table__player--hr-trend .lt-hr-trend-panel {
  width: 100%;
  overflow: visible;
}

/* Light mode — coherent with bright live-training theme */
.light-mode .lt-coach-table {
  --lt-card-bg: #ffffff;
  --lt-card-fg: #0f172a;
  --lt-player-bg: #f1f5f9;
  --lt-player-border: rgba(15, 23, 42, 0.14);
  --lt-meta-fg: #64748b;
  border-color: color-mix(in srgb, var(--lt-table-accent) 40%, #cbd5e1);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  color: var(--lt-card-fg);
}

.light-mode .lt-coach-table--slot-empty {
  background: rgba(241, 245, 249, 0.7);
  border-color: #cbd5e1;
}

.light-mode .lt-coach-table__subgroup,
.light-mode .lt-coach-table__number {
  color: #0f172a;
}

.light-mode .lt-coach-table__name,
.light-mode .lt-coach-table__player--btn .lt-coach-table__name,
.light-mode .lt-coach-table__list-name {
  color: #0f172a;
}

.light-mode .lt-coach-table__stats,
.light-mode .lt-coach-table__player--btn .lt-coach-table__stats,
.light-mode .lt-coach-table__list-meta {
  color: var(--lt-meta-fg);
}

.light-mode .lt-coach-table__side,
.light-mode .lt-coach-table__player--btn .lt-coach-table__side,
.light-mode .lt-coach-table__list-side {
  color: #475569;
}

/* Role tags — dark-theme pastels are invisible on bright player chips */
.light-mode .lt-coach-table__role--active,
.light-mode .lt-coach-table__player--btn .lt-coach-table__role--active {
  background: rgba(34, 179, 92, 0.16);
  color: #15803d;
}

.light-mode .lt-coach-table__role--sparring,
.light-mode .lt-coach-table__player--btn .lt-coach-table__role--sparring {
  background: rgba(243, 140, 41, 0.16);
  color: #c2410c;
}

.light-mode .lt-coach-table__role--both,
.light-mode .lt-coach-table__player--btn .lt-coach-table__role--both {
  background: rgba(14, 165, 233, 0.14);
  color: #0369a1;
}

.light-mode .lt-coach-table__list-role--active {
  color: #15803d;
}

.light-mode .lt-coach-table__list-role--sparring {
  color: #c2410c;
}

.light-mode .lt-coach-table__list-role--both {
  color: #0369a1;
}

.light-mode .lt-coach-table__list-side {
  background: rgba(15, 23, 42, 0.08);
}

.light-mode .lt-coach-table__list-row {
  color: var(--lt-card-fg);
}

.light-mode .lt-coach-table__seat-count {
  color: #0f172a;
  border-color: rgba(15, 23, 42, 0.18);
  background: rgba(15, 23, 42, 0.06);
}

.light-mode .lt-coach-table__classement {
  color: var(--lt-brand, #0877bc);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, #cbd5e1);
}

.light-mode .lt-coach-table__player--btn:not([aria-disabled="true"]):hover,
.light-mode .lt-coach-table__list-row.is-interactive:hover {
  background-color: #e2e8f0;
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, #94a3b8);
}

.light-mode .lt-coach-table__name--voice-hold:active {
  color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #0f172a);
}

.light-mode .lt-coach-table__hr-toggle {
  background: rgba(15, 23, 42, 0.05);
  border-color: rgba(15, 23, 42, 0.12);
  color: #0f172a;
}

.light-mode .lt-coach-table__vs {
  color: #64748b;
}

.light-mode .lt-coach-table__open-seat-label,
html[data-theme="light"] .lt-coach-table__open-seat-label {
  color: #92400e;
}

.light-mode .lt-coach-table__open-seat-btn,
html[data-theme="light"] .lt-coach-table__open-seat-btn {
  background: #fff;
  color: #0f172a;
  border-color: rgba(15, 23, 42, 0.14);
}

.light-mode button.lt-coach-table__open-seat-btn:hover,
html[data-theme="light"] button.lt-coach-table__open-seat-btn:hover {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);
}

html[data-theme="light"] .lt-coach-table {
  --lt-card-bg: #ffffff;
  --lt-card-fg: #0f172a;
  --lt-player-bg: #f1f5f9;
  --lt-player-border: rgba(15, 23, 42, 0.14);
  --lt-meta-fg: #64748b;
}

html[data-theme="light"] .lt-coach-table__name,
html[data-theme="light"] .lt-coach-table__player--btn .lt-coach-table__name,
html[data-theme="light"] .lt-coach-table__list-name {
  color: #0f172a;
}

html[data-theme="light"] .lt-coach-table__stats,
html[data-theme="light"] .lt-coach-table__player--btn .lt-coach-table__stats,
html[data-theme="light"] .lt-coach-table__list-meta {
  color: #64748b;
}

html[data-theme="light"] .lt-coach-table__side,
html[data-theme="light"] .lt-coach-table__player--btn .lt-coach-table__side {
  color: #475569;
}

html[data-theme="light"] .lt-coach-table__role--active,
html[data-theme="light"] .lt-coach-table__player--btn .lt-coach-table__role--active {
  background: rgba(34, 179, 92, 0.16);
  color: #15803d;
}

html[data-theme="light"] .lt-coach-table__role--sparring,
html[data-theme="light"] .lt-coach-table__player--btn .lt-coach-table__role--sparring {
  background: rgba(243, 140, 41, 0.16);
  color: #c2410c;
}

html[data-theme="light"] .lt-coach-table__role--both,
html[data-theme="light"] .lt-coach-table__player--btn .lt-coach-table__role--both {
  background: rgba(14, 165, 233, 0.14);
  color: #0369a1;
}

html[data-theme="light"] .lt-coach-table__list-role--active {
  color: #15803d;
}

html[data-theme="light"] .lt-coach-table__list-role--sparring {
  color: #c2410c;
}

html[data-theme="light"] .lt-coach-table__list-role--both {
  color: #0369a1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/CoachTablePreviewCard.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,iEAAiE;EACjE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,6CAA6C;EAC7C,uCAAuC;EACvC,2FAA2F;EAC3F,mBAAmB;EACnB,iBAAiB;EACjB;;;;;;;qBAOmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,sEAAsE;EACtE,uEAAuE;EACvE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,sCAAsC;EACtC,uEAAuE;AACzE;;AAEA;EACE,uEAAuE;EACvE,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,0GAA0G;EAC1G,2GAA2G;EAC3G,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yEAAyE;EACzE,2EAA2E;AAC7E;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,+DAA+D;EAC/D,yBAAyB;AAC3B;;AAEA;EACE;0FACwF;EACxF;;;;cAIY;EACZ,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,+EAA+E;EAC/E;;;;cAIY;AACd;;AAEA;;EAEE,kFAAkF;EAClF,qFAAqF;AACvF;;AAEA;;EAEE,iDAAiD;EACjD,sFAAsF;AACxF;;AAEA;EACE;;IAEE;;+DAE2D;EAC7D;EACA;IACE;;gEAE4D;EAC9D;AACF;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,iDAAiD;EACjD;;8DAE4D;EAC5D,kGAAkG;EAClG,wBAAwB;EACxB,iEAAiE;EACjE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;EAChC,iFAAiF;EACjF,wBAAwB;EACxB;;4CAE0C;EAC1C,iEAAiE;EACjE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE;IACE,iDAAiD;IACjD,oCAAoC;IACpC,8CAA8C;IAC9C,UAAU;EACZ;EACA;IACE,gDAAgD;IAChD,oCAAoC;IACpC,UAAU;EACZ;EACA;IACE,uCAAuC;IACvC,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,2CAA2C;EAC3C,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,oDAAoD;EACpD,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iFAAiF;;AAEjF;EACE,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,wEAAwE;EACxE,yEAAyE;EACzE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;EACjD,iFAAiF;EACjF;;8DAE4D;EAC5D,iEAAiE;EACjE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,gEAAgE;EAChE;;6CAE2C;EAC3C,iEAAiE;EACjE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mDAAmD;EACnD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;EAChD,oCAAoC;EACpC,8CAA8C;EAC9C,8DAA8D;EAC9D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,0DAA0D;EAC1D,oBAAoB;AACtB;;AAEA;EACE;;IAEE;;gEAE4D;EAC9D;EACA;IACE;;gEAE4D;EAC9D;AACF;;AAEA;EACE;;IAEE;;+CAE2C;IAC3C,yBAAyB;EAC3B;EACA;IACE;;+CAE2C;IAC3C,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,mEAAmE;EACnE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,+EAA+E;EAC/E,mBAAmB;EACnB,qEAAqE;EACrE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,0DAA0D;AAC1D;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,0CAA0C;EAC1C,qBAAqB;EACrB,qEAAqE;EACrE,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,wEAAwE;AACxE;;EAEE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,kEAAkE;EAClE,uEAAuE;AACzE;;AAEA;;EAEE,yBAAyB;EACzB,uEAAuE;AACzE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,oCAAoC;AACtC;;AAEA;;EAEE,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Shared compact table cards — live preview + setup wizard */\n.lt-coach-table {\n  --lt-table-accent: var(--lt-brand, var(--brand-primary, #0877bc));\n  --lt-card-bg: #1e293b;\n  --lt-card-fg: #f8fafc;\n  --lt-player-bg: #293548;\n  --lt-player-border: rgba(255, 255, 255, 0.12);\n  --lt-meta-fg: rgba(248, 250, 252, 0.65);\n  border: 1px solid color-mix(in srgb, var(--lt-table-accent) 32%, rgba(255, 255, 255, 0.12));\n  border-radius: 10px;\n  padding: 8px 10px;\n  background:\n    linear-gradient(\n      90deg,\n      color-mix(in srgb, var(--lt-table-accent) 55%, transparent) 0,\n      color-mix(in srgb, var(--lt-table-accent) 55%, transparent) 4px,\n      transparent 4px\n    ),\n    var(--lt-card-bg);\n  color: var(--lt-card-fg);\n  text-align: left;\n  width: 100%;\n  min-height: 0;\n  box-sizing: border-box;\n}\n\n.lt-coach-table--accent {\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--lt-table-accent) 18%, transparent);\n}\n\n.lt-coach-table--slot-empty {\n  opacity: 0.35;\n  border-style: dashed;\n  background: rgba(30, 41, 59, 0.45);\n  pointer-events: none;\n}\n\n.lt-coach-table__subgroup {\n  display: inline-flex;\n  align-items: center;\n  max-width: 42%;\n  padding: 2px 7px;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--lt-table-accent) 55%, #fff);\n  background: color-mix(in srgb, var(--lt-table-accent) 22%, transparent);\n  color: #f8fafc;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\nbutton.lt-coach-table {\n  font: inherit;\n  color: inherit;\n  appearance: none;\n}\n\n.lt-coach-table--interactive {\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.lt-coach-table--interactive:not(:disabled):hover {\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.6);\n}\n\n.lt-coach-table--selected {\n  border-color: var(--lt-brand, #0877bc);\n  box-shadow: 0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n}\n\n.lt-coach-table--pick-video:not(:disabled) {\n  border-color: color-mix(in srgb, #f87171 55%, rgba(255, 255, 255, 0.2));\n  box-shadow: inset 0 0 0 1px rgba(248, 113, 113, 0.18);\n}\n\n.lt-coach-table--video-selected {\n  border-color: #ef5350;\n  box-shadow: 0 0 0 2px rgba(239, 83, 80, 0.4);\n}\n\n.lt-coach-table--recording {\n  border-color: #dc2626;\n  box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.35);\n}\n\n.lt-coach-table--target:not(:disabled) {\n  border-color: #f59e0b;\n  background: rgba(245, 158, 11, 0.08);\n}\n\n.lt-coach-table__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-weight: 700;\n  font-size: 0.78rem;\n  margin-bottom: 6px;\n  padding-bottom: 5px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-coach-table__number-cluster {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px 6px;\n  min-width: 0;\n  max-width: 70%;\n}\n\n.lt-coach-table__identity {\n  display: inline-flex;\n  align-items: center;\n  padding: 1px 6px;\n  border-radius: 999px;\n  border: 1px solid rgba(251, 191, 36, 0.55);\n  background: rgba(251, 191, 36, 0.14);\n  color: #fbbf24;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  line-height: 1.3;\n}\n\n.lt-coach-table__number {\n  display: inline-flex;\n  align-items: center;\n  padding: 1px 6px;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--lt-table-accent, var(--lt-brand-secondary, #46528b)) 55%, #fff);\n  background: color-mix(in srgb, var(--lt-table-accent, var(--lt-brand-secondary, #46528b)) 22%, transparent);\n  color: #f8fafc;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  line-height: 1.25;\n  flex-shrink: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-coach-table__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 0;\n}\n\n.lt-coach-table__player {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.lt-coach-table__player--left {\n  align-items: flex-start;\n  text-align: left;\n}\n\n.lt-coach-table__player--right {\n  align-items: flex-end;\n  text-align: right;\n}\n\n.lt-coach-table__player--empty .lt-coach-table__name {\n  color: rgba(248, 250, 252, 0.45);\n  font-style: italic;\n  font-weight: 500;\n}\n\n.lt-coach-table__row--open-seat {\n  align-items: stretch;\n}\n\n.lt-coach-table__open-seat {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  align-self: stretch;\n}\n\n.lt-coach-table__open-seat--span {\n  flex: none;\n  width: 100%;\n  margin-top: 4px;\n}\n\n.lt-coach-table__open-seat--right {\n  align-items: flex-end;\n}\n\n.lt-coach-table__open-seat-label {\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: #fde68a;\n}\n\n.lt-coach-table__open-seat-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  width: 100%;\n  max-height: 7.5rem;\n  overflow-y: auto;\n}\n\n.lt-coach-table__open-seat--span .lt-coach-table__open-seat-list {\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.lt-coach-table__open-seat-list > li {\n  margin: 0;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.lt-coach-table__open-seat-btn {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  width: 100%;\n  max-width: 100%;\n  padding: 3px 6px;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(15, 23, 42, 0.35);\n  color: rgba(248, 250, 252, 0.92);\n  font: inherit;\n  font-size: 0.72rem;\n  line-height: 1.2;\n  text-align: left;\n}\n\nbutton.lt-coach-table__open-seat-btn {\n  cursor: pointer;\n}\n\nbutton.lt-coach-table__open-seat-btn:hover {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);\n}\n\n.lt-coach-table__open-seat--right .lt-coach-table__open-seat-btn {\n  text-align: right;\n  flex-direction: row-reverse;\n}\n\n.lt-coach-table__open-seat-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 700;\n}\n\n.lt-coach-table__open-seat-stats {\n  flex-shrink: 0;\n  opacity: 0.7;\n  font-size: 0.64rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-coach-table__player--btn {\n  border: 2px solid var(--lt-player-border);\n  border-radius: 6px;\n  background-color: var(--lt-player-bg);\n  padding: 4px 6px;\n  cursor: pointer;\n  color: var(--lt-card-fg);\n  font: inherit;\n  min-width: 0;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  box-sizing: border-box;\n}\n\n.lt-coach-table__player--btn[aria-disabled=\"true\"] {\n  opacity: 0.55;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.lt-coach-table__player--btn:not([aria-disabled=\"true\"]):hover {\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55);\n  background-color: #3f4f63;\n}\n\n.lt-coach-table__player--swappable {\n  border: 1.5px solid\n    color-mix(in srgb, var(--lt-brand, #0877bc) 45%, rgba(255, 255, 255, 0.16)) !important;\n  background-color: color-mix(\n    in srgb,\n    var(--lt-brand, #0877bc) 10%,\n    var(--lt-player-bg)\n  ) !important;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n}\n\n.lt-coach-table__player--swappable:hover {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 80%, #fff) !important;\n  background-color: color-mix(\n    in srgb,\n    var(--lt-brand, #0877bc) 20%,\n    var(--lt-player-bg)\n  ) !important;\n}\n\n.light-mode .lt-coach-table__player--swappable,\nhtml[data-theme=\"light\"] .lt-coach-table__player--swappable {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 32%, #cbd5e1) !important;\n  background-color: color-mix(in srgb, var(--lt-brand, #0877bc) 6%, #f8fafc) !important;\n}\n\n.light-mode .lt-coach-table__player--swappable:hover,\nhtml[data-theme=\"light\"] .lt-coach-table__player--swappable:hover {\n  border-color: var(--lt-brand, #0877bc) !important;\n  background-color: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #ffffff) !important;\n}\n\n@keyframes lt-coach-table-swappable-pulse {\n  0%,\n  100% {\n    box-shadow:\n      0 0 0 1px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3),\n      0 0 10px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);\n  }\n  50% {\n    box-shadow:\n      0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.5),\n      0 0 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.32);\n  }\n}\n\n.lt-coach-table__player--selected {\n  border-width: 2px !important;\n  border-style: solid !important;\n  border-color: var(--lt-brand, #0877bc) !important;\n  box-shadow:\n    0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45),\n    0 0 14px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n  background-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, var(--lt-player-bg)) !important;\n  color: var(--lt-card-fg);\n  animation: lt-coach-table-selected-glow 1.6s ease-in-out infinite;\n  z-index: 1;\n}\n\n.lt-coach-table__player--target:not([aria-disabled=\"true\"]) {\n  border-width: 2px !important;\n  border-style: dashed !important;\n  border-color: #f59e0b !important;\n  background-color: color-mix(in srgb, #f59e0b 22%, var(--lt-player-bg)) !important;\n  color: var(--lt-card-fg);\n  box-shadow:\n    0 0 0 2px rgba(245, 158, 11, 0.5),\n    inset 0 0 0 1px rgba(253, 230, 138, 0.2);\n  animation: lt-coach-table-target-pulse 1.25s ease-in-out infinite;\n  z-index: 1;\n}\n\n.lt-coach-table__player--dimmed {\n  opacity: 0.38;\n  pointer-events: none;\n  filter: grayscale(0.35);\n}\n\n.lt-coach-table__player--flash {\n  animation: lt-coach-table-swap-flash 1.1s ease-out forwards;\n}\n\n@keyframes lt-coach-table-swap-flash {\n  0% {\n    border-color: rgba(74, 222, 128, 0.95) !important;\n    background-color: #14532d !important;\n    box-shadow: 0 0 0 2px rgba(74, 222, 128, 0.55);\n    opacity: 1;\n  }\n  55% {\n    border-color: rgba(74, 222, 128, 0.7) !important;\n    background-color: #166534 !important;\n    opacity: 1;\n  }\n  100% {\n    border-color: rgba(255, 255, 255, 0.12);\n    background-color: #334155;\n    box-shadow: none;\n    opacity: 1;\n  }\n}\n\n.lt-coach-table__seat-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.25rem;\n  height: 1.25rem;\n  padding: 0 5px;\n  border-radius: 999px;\n  border: 1px solid rgba(125, 211, 252, 0.45);\n  background: rgba(14, 165, 233, 0.18);\n  color: #bae6fd;\n  font-size: 0.62rem;\n  font-weight: 800;\n}\n\n.lt-coach-table__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-height: 0;\n  overflow: visible;\n}\n\n/* 3+: two columns — first half left, second half right; card hugs content */\n.lt-coach-table__list--halves {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 3px 6px;\n  align-content: start;\n  flex: 0 0 auto;\n  overflow: visible;\n}\n\n.lt-coach-table__list-col {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.lt-coach-table__list--scroll {\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: calc(4 * 2.15rem + 12px);\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  padding-right: 2px;\n}\n\n.lt-coach-table--multi {\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  min-height: 0;\n  justify-content: flex-start;\n  overflow: visible;\n  padding: 6px 8px;\n}\n\n.lt-coach-table--multi .lt-coach-table__head {\n  flex-shrink: 0;\n  margin-bottom: 4px;\n  padding-bottom: 4px;\n}\n\n/* Dual cards keep default .lt-coach-table padding (8px 10px / dialog override) */\n\n.lt-coach-table__list-row {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 18px minmax(0, 1fr);\n  gap: 4px;\n  align-items: center;\n  padding: 2px 5px;\n  border-radius: 6px;\n  border: 1px solid var(--lt-player-border);\n  background: var(--lt-player-bg);\n  color: var(--lt-card-fg);\n  text-align: left;\n  cursor: default;\n  min-width: 0;\n  min-height: 2.1rem;\n  box-sizing: border-box;\n}\n\n.lt-coach-table__list-col > li {\n  min-width: 0;\n}\n\n.lt-coach-table__list-row--classement {\n  min-height: 2.2rem;\n}\n\n.lt-coach-table__list--halves .lt-coach-table__list-side {\n  width: 16px;\n  height: 16px;\n  font-size: 0.58rem;\n}\n\n.lt-coach-table__list--halves .lt-coach-table__list-name {\n  font-size: 0.68rem;\n}\n\n.lt-coach-table__list--halves .lt-coach-table__list-meta {\n  font-size: 0.52rem;\n}\n\n.lt-coach-table__rating {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 4px;\n  min-width: 0;\n  max-width: 100%;\n  margin-top: 1px;\n}\n\n.lt-coach-table__rating .lt-coach-table__stats {\n  display: inline;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin: 0;\n}\n\n.lt-coach-table__list-meta.lt-coach-table__rating {\n  display: flex;\n  margin-top: 1px;\n  gap: 4px;\n  line-height: 1.15;\n}\n\n.lt-coach-table__list-role {\n  color: var(--lt-meta-fg, rgba(248, 250, 252, 0.62));\n  white-space: nowrap;\n}\n\n.lt-coach-table__list-role--active {\n  color: #86efac;\n  font-weight: 700;\n}\n\n.lt-coach-table__list-role--sparring {\n  color: #fb923c;\n  font-weight: 700;\n}\n\n.lt-coach-table__list-role--both {\n  color: #7dd3fc;\n  font-weight: 700;\n}\n\n.lt-coach-table__list-role:not(:first-child)::before {\n  content: \"·\";\n  margin-right: 4px;\n  opacity: 0.7;\n}\n\n.lt-coach-table__classement {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.4rem;\n  padding: 1px 5px;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #fff);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);\n  color: #e0f2fe;\n  font-size: 0.6rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  line-height: 1.15;\n}\n\n.lt-coach-table__player--has-classement {\n  gap: 2px;\n}\n\n.lt-coach-table__player--has-classement .lt-coach-table__classement {\n  font-size: 0.62rem;\n  padding: 1px 6px;\n}\n\n.lt-coach-table__list-row.is-interactive {\n  cursor: pointer;\n}\n\n.lt-coach-table__list-row.is-interactive:hover {\n  border-color: rgba(125, 211, 252, 0.55);\n  background: #2d4a63;\n}\n\n.lt-coach-table__list-row.is-selected {\n  border-width: 2px;\n  border-style: solid;\n  border-color: var(--lt-brand, #0877bc) !important;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, var(--lt-player-bg));\n  box-shadow:\n    0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45),\n    0 0 14px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n  animation: lt-coach-table-selected-glow 1.6s ease-in-out infinite;\n  z-index: 1;\n}\n\n.lt-coach-table__list-row.is-target {\n  border-width: 2px;\n  border-style: dashed;\n  border-color: #f59e0b !important;\n  background: color-mix(in srgb, #f59e0b 22%, var(--lt-player-bg));\n  box-shadow:\n    0 0 0 2px rgba(245, 158, 11, 0.5),\n    inset 0 0 0 1px rgba(253, 230, 138, 0.18);\n  animation: lt-coach-table-target-pulse 1.25s ease-in-out infinite;\n  z-index: 1;\n}\n\n.lt-coach-table__list-row.is-dimmed {\n  opacity: 0.38;\n  pointer-events: none;\n  filter: grayscale(0.35);\n}\n\n.lt-coach-table__list-row:disabled {\n  opacity: 0.92;\n  cursor: default;\n}\n\n.lt-coach-table__list-row.is-dimmed:disabled {\n  opacity: 0.38;\n}\n\n.lt-coach-table__list-side {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 0.65rem;\n  font-weight: 800;\n}\n\n.lt-coach-table__list-main {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.lt-coach-table__list-name {\n  font-size: 0.72rem;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n}\n\n.lt-coach-table__list-meta {\n  font-size: 0.58rem;\n  font-weight: 600;\n  color: var(--lt-meta-fg, rgba(248, 250, 252, 0.62));\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n  margin-top: 1px;\n}\n\n.lt-coach-table__player--btn .lt-coach-table__name,\n.lt-coach-table__player--btn .lt-coach-table__stats,\n.lt-coach-table__player--btn .lt-coach-table__side,\n.lt-coach-table__player--btn .lt-coach-table__role {\n  color: inherit;\n}\n\n.lt-coach-table__player--btn .lt-coach-table__name {\n  color: #f8fafc;\n}\n\n.lt-coach-table__player--btn .lt-coach-table__stats {\n  color: rgba(248, 250, 252, 0.78);\n}\n\n.lt-coach-table__player--btn .lt-coach-table__side {\n  color: rgba(248, 250, 252, 0.62);\n}\n\n.lt-coach-table__player-meta {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.lt-coach-table__player--right .lt-coach-table__player-meta {\n  justify-content: flex-end;\n}\n\n.lt-coach-table__side {\n  font-size: 0.6rem;\n  font-weight: 800;\n  color: rgba(248, 250, 252, 0.5);\n  letter-spacing: 0.04em;\n}\n\n.lt-coach-table__role {\n  font-size: 0.58rem;\n  font-weight: 700;\n  padding: 0 5px;\n  border-radius: 4px;\n}\n\n.lt-coach-table__role--active {\n  background: rgba(34, 197, 94, 0.2);\n  color: #86efac;\n}\n\n.lt-coach-table__role--sparring {\n  background: rgba(243, 140, 41, 0.22);\n  color: #fb923c;\n}\n\n.lt-coach-table__role--both {\n  background: rgba(56, 189, 248, 0.2);\n  color: #7dd3fc;\n}\n\n.lt-coach-table__hr-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 2px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.28);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  font-size: 0.68rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: #f8fafc;\n  line-height: 1.2;\n}\n\n.lt-coach-table__player--right .lt-coach-table__hr-chip {\n  align-self: flex-end;\n}\n\n.lt-coach-table__hr-icon {\n  color: #ef4444;\n  font-size: 0.75rem !important;\n}\n\n.lt-coach-table__personalized {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 3px;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.lt-coach-table__personalized-name {\n  font-size: 0.64rem;\n  font-weight: 650;\n  font-style: italic;\n  color: #fde68a;\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-coach-table__personalized-edit {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  background: rgba(253, 230, 138, 0.16);\n  color: #fde68a;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.lt-coach-table__personalized-edit:hover {\n  background: rgba(253, 230, 138, 0.32);\n}\n\n.lt-coach-table__player--right .lt-coach-table__personalized {\n  align-self: flex-end;\n}\n\n.lt-coach-table__name {\n  display: block;\n  font-size: 0.82rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #f8fafc;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.lt-coach-table__name--voice-hold {\n  cursor: pointer;\n  touch-action: manipulation;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.lt-coach-table__name--voice-hold:active {\n  color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 45%, #f8fafc);\n}\n\n.lt-coach-table__stats {\n  display: block;\n  font-size: 0.68rem;\n  color: rgba(248, 250, 252, 0.55);\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.lt-coach-table__vs {\n  flex-shrink: 0;\n  font-size: 0.62rem;\n  font-weight: 800;\n  color: rgba(248, 250, 252, 0.35);\n  padding: 0 2px;\n}\n\n.lt-coach-table__score-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 0.95rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.lt-coach-table__score-win {\n  color: #86efac;\n}\n\n.lt-coach-table__score-lose {\n  color: rgba(248, 250, 252, 0.45);\n}\n\n.lt-coach-table__score-sep {\n  color: rgba(248, 250, 252, 0.35);\n  font-weight: 600;\n}\n\n.lt-coach-table__player--swap-warn:not([aria-disabled=\"true\"]) {\n  border-color: rgba(239, 68, 68, 0.55) !important;\n  background-color: #4a2424 !important;\n}\n\n.lt-coach-table__player--swapping {\n  border-color: rgba(56, 189, 248, 0.7) !important;\n  background-color: #1e3a4f !important;\n  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25);\n  animation: lt-coach-table-swap-pulse 1.1s ease-in-out infinite;\n  position: relative;\n  overflow: hidden;\n}\n\n.lt-coach-table__player--swapping::after {\n  content: \"\";\n  position: absolute;\n  inset: -1px;\n  border-radius: 6px;\n  border: 2px solid rgba(125, 211, 252, 0.55);\n  animation: lt-coach-table-swap-ring 1.4s ease-out infinite;\n  pointer-events: none;\n}\n\n@keyframes lt-coach-table-selected-glow {\n  0%,\n  100% {\n    box-shadow:\n      0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4),\n      0 0 12px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n  }\n  50% {\n    box-shadow:\n      0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.65),\n      0 0 22px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45);\n  }\n}\n\n@keyframes lt-coach-table-target-pulse {\n  0%,\n  100% {\n    box-shadow:\n      0 0 0 2px rgba(245, 158, 11, 0.45),\n      inset 0 0 0 1px rgba(253, 230, 138, 0.15);\n    background-color: #4a3a18;\n  }\n  50% {\n    box-shadow:\n      0 0 0 2px rgba(251, 191, 36, 0.85),\n      inset 0 0 0 1px rgba(253, 230, 138, 0.28);\n    background-color: #5c4518;\n  }\n}\n\n@keyframes lt-coach-table-swap-pulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.88;\n    transform: scale(0.99);\n  }\n}\n\n@keyframes lt-coach-table-swap-ring {\n  0% {\n    opacity: 0.85;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1.06);\n  }\n}\n\n.lt-coach-table__swap-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  align-self: flex-start;\n  margin-bottom: 4px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  font-size: 0.6rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.lt-coach-table__player--right .lt-coach-table__swap-badge {\n  align-self: flex-end;\n}\n\n.lt-coach-table__swap-badge svg {\n  font-size: 0.85rem !important;\n}\n\n.lt-coach-table__swap-badge--selected {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55);\n  color: #bae6fd;\n}\n\n.lt-coach-table__swap-badge--target {\n  background: rgba(245, 158, 11, 0.22);\n  border: 1px solid rgba(245, 158, 11, 0.55);\n  color: #fde68a;\n  animation: lt-coach-table-badge-bounce 1.4s ease-in-out infinite;\n}\n\n.lt-coach-table__swap-badge--swapping {\n  background: rgba(56, 189, 248, 0.2);\n  border: 1px solid rgba(56, 189, 248, 0.5);\n  color: #bae6fd;\n}\n\n.lt-coach-table__swap-spin {\n  animation: lt-coach-table-swap-spin 0.9s linear infinite;\n}\n\n@keyframes lt-coach-table-swap-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes lt-coach-table-badge-bounce {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-1px);\n  }\n}\n\n.lt-coach-table__swap-retry {\n  margin-top: 4px;\n  padding: 2px 8px;\n  border-radius: 6px;\n  border: 1px solid rgba(239, 68, 68, 0.45);\n  background: rgba(239, 68, 68, 0.14);\n  color: #fecaca;\n  font-size: 0.62rem;\n  font-weight: 700;\n  cursor: pointer;\n  font: inherit;\n}\n\n.lt-coach-table__tap-hint {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.62rem;\n  font-weight: 700;\n  color: #fcd34d;\n}\n\n.lt-coach-table--done {\n  border-color: rgba(34, 197, 94, 0.35);\n  background: rgba(34, 197, 94, 0.08);\n}\n\n.lt-coach-table--done.lt-coach-table--interactive:not(:disabled) {\n  cursor: default;\n  opacity: 0.92;\n}\n\n.lt-coach-table__record-menu {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0;\n  min-width: 200px;\n  background: white;\n}\n\n.lt-coach-table__record-menu-btn {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border: none;\n  background: transparent;\n  color: #1e293b;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.lt-coach-table__record-menu-btn:hover {\n  background: #f1f5f9;\n}\n\n.lt-coach-table__player--pick-target {\n  outline: 2px dashed rgba(251, 191, 36, 0.85);\n  outline-offset: 2px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.lt-coach-table__player--pick-target .lt-coach-table__name--voice-hold {\n  color: #fcd34d;\n}\n\n.lt-coach-table__player--recording {\n  outline: 2px solid rgba(239, 68, 68, 0.75);\n  outline-offset: 2px;\n  border-radius: 8px;\n}\n\n.lt-coach-table__stop-capture-btn,\n.lt-coach-table__start-capture-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 0 8px;\n  border-radius: 6px;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  line-height: inherit;\n  cursor: pointer;\n}\n\n.lt-coach-table__stop-capture-btn svg,\n.lt-coach-table__start-capture-btn svg {\n  font-size: 1em;\n}\n\n.lt-coach-table__stop-capture-btn {\n  border: 1px solid #ef4444;\n  background: rgba(239, 68, 68, 0.15);\n  color: #ef4444;\n}\n\n.lt-coach-table__start-capture-btn {\n  border: 1px solid rgba(248, 113, 113, 0.75);\n  background: rgba(239, 68, 68, 0.18);\n  color: #fecaca;\n}\n\n.lt-coach-table__start-capture-btn:hover {\n  background: rgba(239, 68, 68, 0.3);\n  color: #fff;\n}\n\n.lt-recording-indicator.blinking {\n  animation: blink 1s infinite;\n}\n\n@keyframes blink {\n  0% { opacity: 1; }\n  50% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n.lt-coach-table__hr-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 36px;\n  min-height: 36px;\n  margin-left: auto;\n  padding: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.25);\n  color: #f8fafc;\n  cursor: pointer;\n}\n\n.lt-coach-table__hr-toggle:hover {\n  background: rgba(8, 119, 188, 0.25);\n}\n\n.lt-coach-table__eval-video {\n  position: relative;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-width: 36px;\n  min-height: 36px;\n  margin-left: auto;\n  padding: 6px 8px;\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 60%, transparent);\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 85%, #0f172a);\n  color: #fff;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n  pointer-events: auto;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.lt-coach-table__eval-video:hover {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 75%, #fff);\n}\n\n.lt-coach-table__eval-video + .lt-coach-table__hr-toggle {\n  margin-left: 6px;\n}\n\n.lt-coach-table__eval-video-count {\n  line-height: 1;\n}\n\n.lt-coach-table--hr-trend .lt-coach-table__row {\n  align-items: stretch;\n}\n\n.lt-coach-table__player--hr-trend {\n  gap: 6px;\n  min-width: 0;\n}\n\n.lt-coach-table--hr-trend {\n  overflow: visible;\n}\n\n.lt-coach-table__player--hr-trend .lt-hr-trend-panel {\n  width: 100%;\n  overflow: visible;\n}\n\n/* Light mode — coherent with bright live-training theme */\n.light-mode .lt-coach-table {\n  --lt-card-bg: #ffffff;\n  --lt-card-fg: #0f172a;\n  --lt-player-bg: #f1f5f9;\n  --lt-player-border: rgba(15, 23, 42, 0.14);\n  --lt-meta-fg: #64748b;\n  border-color: color-mix(in srgb, var(--lt-table-accent) 40%, #cbd5e1);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n  color: var(--lt-card-fg);\n}\n\n.light-mode .lt-coach-table--slot-empty {\n  background: rgba(241, 245, 249, 0.7);\n  border-color: #cbd5e1;\n}\n\n.light-mode .lt-coach-table__subgroup,\n.light-mode .lt-coach-table__number {\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-table__name,\n.light-mode .lt-coach-table__player--btn .lt-coach-table__name,\n.light-mode .lt-coach-table__list-name {\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-table__stats,\n.light-mode .lt-coach-table__player--btn .lt-coach-table__stats,\n.light-mode .lt-coach-table__list-meta {\n  color: var(--lt-meta-fg);\n}\n\n.light-mode .lt-coach-table__side,\n.light-mode .lt-coach-table__player--btn .lt-coach-table__side,\n.light-mode .lt-coach-table__list-side {\n  color: #475569;\n}\n\n/* Role tags — dark-theme pastels are invisible on bright player chips */\n.light-mode .lt-coach-table__role--active,\n.light-mode .lt-coach-table__player--btn .lt-coach-table__role--active {\n  background: rgba(34, 179, 92, 0.16);\n  color: #15803d;\n}\n\n.light-mode .lt-coach-table__role--sparring,\n.light-mode .lt-coach-table__player--btn .lt-coach-table__role--sparring {\n  background: rgba(243, 140, 41, 0.16);\n  color: #c2410c;\n}\n\n.light-mode .lt-coach-table__role--both,\n.light-mode .lt-coach-table__player--btn .lt-coach-table__role--both {\n  background: rgba(14, 165, 233, 0.14);\n  color: #0369a1;\n}\n\n.light-mode .lt-coach-table__list-role--active {\n  color: #15803d;\n}\n\n.light-mode .lt-coach-table__list-role--sparring {\n  color: #c2410c;\n}\n\n.light-mode .lt-coach-table__list-role--both {\n  color: #0369a1;\n}\n\n.light-mode .lt-coach-table__list-side {\n  background: rgba(15, 23, 42, 0.08);\n}\n\n.light-mode .lt-coach-table__list-row {\n  color: var(--lt-card-fg);\n}\n\n.light-mode .lt-coach-table__seat-count {\n  color: #0f172a;\n  border-color: rgba(15, 23, 42, 0.18);\n  background: rgba(15, 23, 42, 0.06);\n}\n\n.light-mode .lt-coach-table__classement {\n  color: var(--lt-brand, #0877bc);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, #cbd5e1);\n}\n\n.light-mode .lt-coach-table__player--btn:not([aria-disabled=\"true\"]):hover,\n.light-mode .lt-coach-table__list-row.is-interactive:hover {\n  background-color: #e2e8f0;\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, #94a3b8);\n}\n\n.light-mode .lt-coach-table__name--voice-hold:active {\n  color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #0f172a);\n}\n\n.light-mode .lt-coach-table__hr-toggle {\n  background: rgba(15, 23, 42, 0.05);\n  border-color: rgba(15, 23, 42, 0.12);\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-table__vs {\n  color: #64748b;\n}\n\n.light-mode .lt-coach-table__open-seat-label,\nhtml[data-theme=\"light\"] .lt-coach-table__open-seat-label {\n  color: #92400e;\n}\n\n.light-mode .lt-coach-table__open-seat-btn,\nhtml[data-theme=\"light\"] .lt-coach-table__open-seat-btn {\n  background: #fff;\n  color: #0f172a;\n  border-color: rgba(15, 23, 42, 0.14);\n}\n\n.light-mode button.lt-coach-table__open-seat-btn:hover,\nhtml[data-theme=\"light\"] button.lt-coach-table__open-seat-btn:hover {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);\n}\n\nhtml[data-theme=\"light\"] .lt-coach-table {\n  --lt-card-bg: #ffffff;\n  --lt-card-fg: #0f172a;\n  --lt-player-bg: #f1f5f9;\n  --lt-player-border: rgba(15, 23, 42, 0.14);\n  --lt-meta-fg: #64748b;\n}\n\nhtml[data-theme=\"light\"] .lt-coach-table__name,\nhtml[data-theme=\"light\"] .lt-coach-table__player--btn .lt-coach-table__name,\nhtml[data-theme=\"light\"] .lt-coach-table__list-name {\n  color: #0f172a;\n}\n\nhtml[data-theme=\"light\"] .lt-coach-table__stats,\nhtml[data-theme=\"light\"] .lt-coach-table__player--btn .lt-coach-table__stats,\nhtml[data-theme=\"light\"] .lt-coach-table__list-meta {\n  color: #64748b;\n}\n\nhtml[data-theme=\"light\"] .lt-coach-table__side,\nhtml[data-theme=\"light\"] .lt-coach-table__player--btn .lt-coach-table__side {\n  color: #475569;\n}\n\nhtml[data-theme=\"light\"] .lt-coach-table__role--active,\nhtml[data-theme=\"light\"] .lt-coach-table__player--btn .lt-coach-table__role--active {\n  background: rgba(34, 179, 92, 0.16);\n  color: #15803d;\n}\n\nhtml[data-theme=\"light\"] .lt-coach-table__role--sparring,\nhtml[data-theme=\"light\"] .lt-coach-table__player--btn .lt-coach-table__role--sparring {\n  background: rgba(243, 140, 41, 0.16);\n  color: #c2410c;\n}\n\nhtml[data-theme=\"light\"] .lt-coach-table__role--both,\nhtml[data-theme=\"light\"] .lt-coach-table__player--btn .lt-coach-table__role--both {\n  background: rgba(14, 165, 233, 0.14);\n  color: #0369a1;\n}\n\nhtml[data-theme=\"light\"] .lt-coach-table__list-role--active {\n  color: #15803d;\n}\n\nhtml[data-theme=\"light\"] .lt-coach-table__list-role--sparring {\n  color: #c2410c;\n}\n\nhtml[data-theme=\"light\"] .lt-coach-table__list-role--both {\n  color: #0369a1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
